import { http } from '../../core/services';

const scheduleConsultation = values =>
  http.post(`/api/consultation-requests/with-extra-info`, values).then(response => response.data);

export default scheduleConsultation;
